import { showExportWithAIWatermarkDialog } from "@/components/AIWatermarkDialog";
import HBMessage from "@/components/HBMessage";
import { BuyVipDialog } from "@/components/Vip";
import { LOCAL_STORAGE_KEY } from "@/constants/localStorageKey";
import useAppStore from "@/context/store";
import { getDownloadUrl, getGrocery, getPin } from "@/services";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import {
  AiWatermarkType,
  downloadBlob,
  exportImageWithWatermark,
} from "./aiWatermark";
import { safeParse } from "./safeParse";

dayjs.extend(isBetween);

export function getMaterialFiles(pin: IPin) {
  const info = pin.material_info;
  const material = pin.file_material;

  let files = [];

  if (
    material.material_category === "平面模板" ||
    material.material_category === "视频模板"
  ) {
    const file = info?.files?.find((file) => file.file_type === "ORIGIN");
    if (file) {
      files.push(file);
    }
  } else if (material.material_category === "视频") {
    const mps = info?.content?.mps?.find((mps) => {
      return mps.name === "HD";
    });
    if (mps) {
      files.push({
        file_format: mps.file_format,
        file_size: mps.file_size,
        file_type: mps.name,
      });
    }
  } else {
    files = info?.files || [];
  }

  return files;
}

export function handleDownloadFileName(pin: IPin, file) {
  let name = [
    "花瓣素材",
    // 限制文件名长度，避免文件名过长
    pin?.raw_text?.substring(0, 50) || new Date().getTime(),
    pin.material_info?.id,
  ].join("_");
  let ext = file?.file_format ? "." + file?.file_format : "";

  let filename = name + ext;

  // 非法字符替换（Windows下不允许以下字符：\/:*?"<>|，Mac OS下不允许以下字符：/）
  filename = filename.replace(/[/:*?"<>|]/g, "-");

  //判断文件名是否以空格结尾（不允许）
  filename = filename.replace(/\s+$/, "");

  return filename;
}

export const getTypeNum = (category) => {
  switch (category) {
    case "图片":
      return 1;
    case "视频":
      return 3;
    case "平面模板":
      return 4;
    case "高端免抠":
      return 5;
    case "视频模板":
      return 6;
  }
};

export function aLinkDownload(url: string, fileName?: string) {
  const a = document.createElement("a");
  a.href = url;
  if (fileName) {
    a.download = fileName;
  }
  a.click();
  a.remove();
}

/**
 * 下载文件（带 AI 水印处理）
 * @param url 下载地址
 * @param pin 素材信息（可选，用于判断是否为AI内容）
 */
export async function downloadWithAIWatermarkCheck(
  url: string,
  pin?: IPin
): Promise<void> {
  // 判断是否为AI内容
  const aigcValue = pin?.extra?.aigc;
  const isAIContent = aigcValue !== undefined && aigcValue > 0;

  // 非 AI 内容或没有 pin 信息，直接下载
  if (!isAIContent || !pin) {
    aLinkDownload(url);
    return;
  }

  // AI 内容：需要处理水印逻辑
  try {
    const fileExtension = url.split(".").pop() || "png";
    const fileName = pin.raw_text
      ? `${pin.raw_text.substring(0, 50)}_${pin.pin_id}`
      : `素材_${pin.pin_id}`;

    const supportedFormats = ["png", "jpg", "jpeg"];
    // 只有图片支持加水印
    if (!supportedFormats.includes(fileExtension)) {
      aLinkDownload(url, `${fileName}.${fileExtension}`);
      return;
    }

    const blob = await showExportWithAIWatermarkDialog((isDrawAIWatermark) => {
      return exportImageWithWatermark(
        url,
        isDrawAIWatermark,
        AiWatermarkType.GD_AI_WATERMARK
        // pin.user?.username, 暂时不需要加上用户名
      );
    });

    // 下载处理后的图片
    downloadBlob(blob, `${fileName}.${fileExtension}`);
  } catch (error) {
    // 用户取消或处理失败，降级为普通下载
    if (error && (error as Error).message !== "User cancelled") {
      HBMessage.info("AI 水印处理失败，已使用普通下载");
    }
    aLinkDownload(url);
  }
}

let gaodingEditorFileCheckData = null;
export async function filterFilesEditOnline(files: IFile[]) {
  if (!gaodingEditorFileCheckData) {
    gaodingEditorFileCheckData = await getGrocery("gaoding-editor-file-check");
  }

  return (
    files?.filter((file) => {
      const item = gaodingEditorFileCheckData?.list?.find((item) =>
        item.types.includes(file?.file_format?.toLowerCase())
      );
      return item && file?.file_size / (1024 * 1024) <= item.maxSize;
    }) || []
  );
}
// 去稿定编辑器编辑（判断多文件和文件格式是否支持）
// export async function handleEditOnline({
//   pin,
//   searchWord,
// }: {
//   pin: IPin;
//   searchWord?: string;
// }) {
//   // 判断登录
//   const user = useAppStore.getState().user;

//   if (!user) {
//     LoginDialog.open({
//       onOk() {
//         handleEditOnline({
//           pin,
//           searchWord,
//         });
//       },
//     });

//     return;
//   }

//   if (!pin?.material_info) {
//     return;
//   }

//   const files = getMaterialFiles(pin);
//   // 过滤编辑器不支持的文件格式
//   const newFiles = await filterFilesEditOnline(files);
//   if (newFiles.length > 1) {
//     // 如果有多个格式文件让用户选择
//     MaterialFileTypeSelectModal.open({
//       files: newFiles,
//       pin,
//       onOk: (file) => {
//         handleDownload({ pin, file, searchWord, editOnline: true });
//       },
//     });
//   } else if (newFiles.length === 1) {
//     handleDownload({ pin, file: newFiles[0], searchWord, editOnline: true });
//   } else {
//     HBModalConfirm.open({
//       title: "编辑提示",
//       content: "当前素材暂不支持「在线编辑」，请选择其他素材",
//       okText: "知道了",
//     });
//   }
// }
// 用于下载历史的去稿定编辑器编辑（因为不需要扣权益就可以取到url，所以可以取到下载链接）
// export async function handleEditOnlineWithUrl(
//   pin_id: number,
//   material_type: string
// ) {
//   const user = useAppStore.getState().user;

//   const { pin, err, msg } = await getPin({
//     pin_id,
//     ignoreMessage: true,
//   });

//   if (err === 404) {
//     HBMessage.error("素材已下架");
//     return;
//   }

//   if (err || !pin) {
//     HBMessage.error(msg || "素材获取失败");
//     return;
//   }

//   // 稿定自产模版素材不需要扣权益直接跳
//   if (
//     pin?.material_info?.source_type === "produced" &&
//     pin?.material_info.categories?.includes("模板")
//   ) {
//     window.open(
//       `https://${gaodingEditHost}/editor/design?id=${pin?.material_info?.id}`
//     );
//     return;
//   }

//   // 获取下载地址
//   const result = await getMaterialUrlAndFile(pin_id, material_type);
//   if (!result) {
//     return;
//   }

//   const { url, file } = result;

//   // 没绑定租户，跳去绑定
//   if (!user?.extra?.org_id) {
//     window.location.href = `/gdmerge?state=${encodeURIComponent(
//       window.location.href
//     )}`;
//     return;
//   }
//   // 过滤编辑器不支持的文件格式
//   const files = await filterFilesEditOnline([file]);
//   if (files.length === 1) {
//     window.location.href = `https://${gaodingEditHost}/editor/design?mode=open_remote_file&resource_url=${encodeURIComponent(
//       url
//     )}&action_extension=autofocus`;
//   } else {
//     HBModalConfirm.open({
//       title: "编辑提示",
//       content: "当前素材暂不支持「在线编辑」，请选择其他素材",
//       okText: "知道了",
//     });
//   }
// }

// const downloadDialogRef = { current: null };
// export async function handleDownload({
//   pin,
//   file,
//   searchWord,
// }: // editOnline,
// {
//   pin: IPin;
//   file: IFile;
//   searchWord?: string;
//   // editOnline?: boolean;
// }) {
//   // 判断登录
//   const user = useAppStore.getState().user;

//   if (!user) {
//     LoginDialog.open({
//       onOk() {
//         handleDownload({
//           pin,
//           file,
//           searchWord,
//           // editOnline,
//         });
//       },
//     });

//     return;
//   }

//   // if (editOnline) {
//   //   // 判断是否是稿定自产模板素材
//   //   if (
//   //     pin?.material_info?.source_type === "produced" &&
//   //     pin?.material_info.categories?.includes("模板")
//   //   ) {
//   //     // 稿定自产模板素材不需要扣权益直接跳
//   //     window.open(
//   //       `https://${gaodingEditHost}/editor/design?id=${pin?.material_info?.id}`
//   //     );
//   //     return;
//   //   } else {
//   //     // 判断是否绑定租户
//   //     if (user?.extra?.org_id) {
//   //       const result = await getMeOrg({
//   //         org: true,
//   //         org_role: true,
//   //       });
//   //       // 错误的话不继续走下去
//   //       if (result?.err) {
//   //         return;
//   //       }
//   //       // 如果是访客提示无权访问
//   //       if (result?.org_role?.roleEnum === "VISITOR") {
//   //         GdPermissionDialog.open({
//   //           type: GD_PERMISSION_TYPE.visitor,
//   //           operation: "在线编辑",
//   //         });
//   //         return;
//   //         // 如果被移除了角色提示角色被移除
//   //       } else if (!result?.org_role?.roleEnum) {
//   //         GdPermissionDialog.open({
//   //           type: GD_PERMISSION_TYPE.remove,
//   //           operation: "在线编辑",
//   //         });
//   //         return;
//   //       }
//   //     } else {
//   //       // 没绑定租户，跳去绑定
//   //       window.location.href = `/gdmerge?state=${encodeURIComponent(
//   //         window.location.href
//   //       )}`;
//   //       return;
//   //     }
//   //   }
//   // }

//   const latestUser = await useAppStore.getState().refreshUser();

//   let org = null;
//   if (latestUser?.extra?.org_id) {
//     const result = await getMeOrg({
//       org: true,
//       org_role: true,
//     });
//     // 错误的话不继续走下去
//     if (result?.err) {
//       return;
//     }
//     org = result;
//     // 如果是访客提示无权访问
//     if (result?.org_role?.roleEnum === ORG_ROLE.VISITOR) {
//       GdPermissionDialog.open({
//         type: GD_PERMISSION_TYPE.visitor,
//         operation: "下载",
//       });
//       return;
//       // 如果被移除了角色提示角色被移除
//     } else if (!result?.org_role?.roleEnum) {
//       GdPermissionDialog.open({
//         type: GD_PERMISSION_TYPE.remove,
//         operation: "下载",
//       });
//       return;
//     }

//     const orgs = await getGdUserOrgs();
//     // 错误的话不继续走下去
//     if (result?.err) {
//       return;
//     }

//     if (
//       orgs.find(
//         (item) => item.org_id === result?.org?.id?.value && !item?.hb_vip_name
//       ) &&
//       orgs?.some(
//         (item) => !!item?.hb_vip_name && item.org_id !== result?.org?.id?.value
//       )
//     ) {
//       GdPermissionDialog.open({
//         type: GD_PERMISSION_TYPE.noauth,
//         operation: "下载",
//       });
//       return;
//     }
//   }

//   // 获取用户权益信息
//   const [userRights, vips] = await Promise.all([
//     getBizUserRightList({
//       page_size: 200,
//       status: 1,
//       not_expired: 1,
//     }),
//     getCurrentVip(),
//   ]);

//   // 是否有会员，没有会员打开购买弹窗
//   if (!(vips?.length > 0)) {
//     BuyVipDialog.open({
//       searchWord,
//       onFinish: () =>
//         handleDownload({
//           pin,
//           file,
//           searchWord,
//           // editOnline,
//         }),
//     });

//     return;
//   }

//   // 有商用授权
//   const hasAuth = !isNoAuthByUser(latestUser);

//   let subjectList = null;
//   let latestCertSubjectId = null;

//   // 商用授权需要检查授权主体
//   if (hasAuth) {
//     // 判断是否需要填写授权主体
//     const subjectRes = await getCertList({ valid: 1, page_size: 200 });

//     if (!subjectRes.list?.length) {
//       return HBMessage.error("未获取到授权主体信息，请稍后再试");
//     }

//     subjectList = subjectRes.list;

//     const validSubject = subjectRes.list.filter(
//       (item) => item.subject_info?.id_no
//     );

//     if (validSubject.length === 0) {
//       if (org && org?.org?.admin?.value !== org?.org?.id?.value) {
//         HBMessage.error(
//           "授权主体信息未填写，且您的身份无授权主体填写权限，请联系管理员"
//         );
//         return;
//       }

//       // 需要填写授权主体
//       AuthSubjectDialog.open({
//         vipId: vips[0].vip_id,
//         certSubject: subjectRes.list[0],
//         onOk: () =>
//           handleDownload({
//             pin,
//             file,
//             searchWord,
//             // editOnline,
//           }),
//       });

//       return;
//     }

//     // 未填写授权主题
//     const noInfoSubject = subjectRes.list.find(
//       (item) => !item.subject_info?.id_no
//     );

//     // 当存在多主体时，且有未填写授权主体时，弹窗提示
//     if (
//       subjectRes.list.length > 1 &&
//       noInfoSubject &&
//       !localStorage.getItem(LOCAL_STORAGE_KEY.HB_MUTI_SUBJECT_TIP)
//     ) {
//       try {
//         await MutiSubjectTipModal.asyncOpen({
//           subjects: subjectRes.list,
//         });
//       } catch (error) {
//         return;
//       }
//     }

//     latestCertSubjectId = [validSubject[0].id];
//     // 当存在多个授权主体时，需要默认选中最近使用的授权主体
//     if (validSubject.length > 1) {
//       // 通过最近下载记录获取最近使用的授权主体
//       const res = await getBizDownloadList({ page_size: 1 });
//       if (res.list?.length) {
//         const id = res.list[0].vip_cert_subject_id;
//         if (validSubject.find((item) => item.id === id)) {
//           latestCertSubjectId = [id];
//         }
//       }
//     }
//   }

//   const info = pin?.material_info;
//   const material = pin?.file_material;

//   // 调用预下载接口，判断是否可以下载
//   const result = await getPreDownloadInfo({
//     material_id: info?.id,
//     download_type: 1,
//     type: getTypeNum(material?.material_category),
//     vip_cert_subject_ids: latestCertSubjectId,
//   });

//   if (result.err) {
//     HBMessage.error("当前素材无法被下载");
//     return;
//   }

//   // 判断会员有没有，下载权益有没有
//   if (result.vips.length <= 0 || result.rights.length <= 0) {
//     BuyVipDialog.open({
//       searchWord,
//       onFinish: () =>
//         handleDownload({
//           pin,
//           file,
//           searchWord,
//           // editOnline,
//         }),
//     });

//     return;
//   }

//   // 单品类会员是否有下载权益
//   if (!result.has_right_package) {
//     SingleCategoryModal.open({
//       currentVipType: getVipTypeById(vips[0].vip_id),
//     });

//     return;
//   }

//   // 避免触发多个弹窗
//   if (downloadDialogRef.current?.destroy) {
//     downloadDialogRef.current.destroy();
//   }

//   downloadDialogRef.current = MaterialDownloadDialog.open({
//     pin,
//     info: result,
//     file,
//     searchWord,
//     userRights: userRights.list,
//     subjects: subjectList,
//     defaultSelectSubject: latestCertSubjectId,
//     // editOnline,
//     onDownload: () =>
//       handleDownload({
//         pin,
//         file,
//         searchWord,
//         // editOnline,
//       }),
//   });
// }

/** 获取素材的下载地址 */
export async function getMaterialUrlAndFile(
  pin_id: number | string,
  material_type: string
) {
  const vips = useAppStore.getState().vips;

  if (vips.length === 0) {
    BuyVipDialog.open();
    return;
  }

  const { pin, err, msg } = await getPin({
    pin_id,
    ignoreMessage: true,
  });

  if (err === 404) {
    HBMessage.error("素材已下架");
    return;
  }

  if (err || !pin) {
    HBMessage.error(msg || "素材获取失败");
    return;
  }

  const files = getMaterialFiles(pin);
  const file =
    files.find(
      (file) =>
        file?.file_format?.toLowerCase() === material_type?.toLowerCase()
    ) || files[0];
  let format = "";

  if (pin?.file_material?.material_category === "视频") {
    format = "HD";
  } else if (pin?.file_material?.material_category === "高端免抠") {
    format = file.file_type;
  }

  const { url } = await getDownloadUrl({
    material_id: pin?.material_info?.id,
    download_type: 1,
    filename: handleDownloadFileName(pin, file),
    ...(format ? { format } : null),
    type: getTypeNum(pin?.file_material?.material_category),
    // system_code: vips[0].system_code,
  });

  return { url, file, pin };
}

// export async function downloadByPinId(pinId: number | string) {
//   const result = await getPin({ pin_id: pinId });

//   // 获取采集失败
//   if (result?.err) {
//     HBMessage.error("当前素材无法被下载");
//     return;
//   }

//   const pin = result?.pin;

//   const info = pin?.material_info;
//   const material = pin?.file_material;

//   // 判断素材详情信息是否存在
//   if (!material || material?.err === 404) {
//     HBMessage.error("当前素材无法被下载");
//     return;
//   }

//   // 获取file信息
//   let file = null;
//   if (material?.material_category === "视频") {
//     const mps = info?.content?.mps?.find((mps) => {
//       return mps.name === "HD";
//     });
//     if (mps) {
//       file = {
//         file_format: mps.file_format,
//         file_size: mps.file_size,
//         file_type: mps.name,
//       };
//     }
//   } else {
//     file = info?.files?.find((file) => file.file_type === "ORIGIN") || null;
//   }

//   if (!file) {
//     HBMessage.error("当前素材无法被下载");
//     return;
//   }

//   // 调用下载方法
//   const downloadProcess = new DownloadProcess({
//     pin,
//     file,
//   });

//   downloadProcess.processDownloadMaterial();
// }

export function saveDownloadClickCount() {
  const count = getDownloadClickCount();
  // 今天日期
  const todayDate = dayjs().format("YYYY-MM-DD");

  const res = {
    date: todayDate,
    count: count + 1,
  };

  localStorage.setItem(
    LOCAL_STORAGE_KEY.HB_DOWNLOAD_CLICK_COUNT,
    JSON.stringify(res)
  );

  return res;
}

export function getDownloadClickCount() {
  const saved = safeParse(
    localStorage.getItem(LOCAL_STORAGE_KEY.HB_DOWNLOAD_CLICK_COUNT) || `{}`
  );
  // 今天日期
  const todayDate = dayjs().format("YYYY-MM-DD");
  // 只记录当天的点击次数
  return saved.date === todayDate ? saved.count || 0 : 0;
}
